export default "__VITE_ASSET__01930ea7__"